"use client";

import { ArrowRight, Square } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function UnveilingYourRadiance() {
  const line1 = "UNVEILING";
  const line2 = "YOUR RADIANCE";
  const conditions = [{
    label: "STYLE",
    value: "BRIDAL"
  }, {
    label: "FINISH",
    value: "GLAM"
  }, {
    label: "ARTISTRY",
    value: "CUSTOM"
  }];
  return <section data-section-id="2164" id="unveiling-your-radiance" className="bg-[#FAF6F1] text-[#1A1512] relative w-full min-h-[820px] h-screen overflow-hidden flex flex-col">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/bridal_makeup_editorial_glow.png)]" aria-hidden="true" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#FAF6F1]/40 via-transparent to-[#FAF6F1]/80" aria-hidden="true" />

      <div className="relative z-10 h-full flex flex-col flex-1">
        {}
        <div className="flex items-start justify-between px-6 md:px-12 pt-8 md:pt-10 animate-in fade-in duration-1000">
          <div className="flex items-center gap-2 font-mono text-[10px] sm:text-xs uppercase tracking-[0.2em] text-[#1A1512]/80">
            <Square className="size-2.5 fill-[#D4AF9F] text-[#D4AF9F]" strokeWidth={0} />
            <span>[ EST. 2020 — JOANNE GLOW STUDIO ]</span>
          </div>
        </div>

        {}
        <div className="flex-1 flex items-center px-6 md:px-12">
          <div className="w-full max-w-5xl animate-in fade-in slide-in-from-bottom-4 duration-1000 delay-200" aria-label="Unveiling Your Radiance">
            <h1 className="font-sans font-extrabold uppercase leading-[0.9] text-[#1A1512]" style={{
            fontSize: "clamp(56px, 11vw, 180px)",
            letterSpacing: "-0.04em"
          }}>
              <span className="block">
                {line1}
              </span>
              <span className="block ml-[0.5em] sm:ml-[1em]">
                {line2}
              </span>
            </h1>
          </div>
        </div>

        {}
        <div className="px-6 md:px-12 pb-12 md:pb-16 grid grid-cols-1 lg:grid-cols-12 gap-10 items-end animate-in fade-in slide-in-from-bottom-4 duration-1000 delay-500">
          {}
          <div className="lg:col-span-7">
            <p className="font-sans text-[#1A1512]/90 max-w-[520px] mb-8 leading-relaxed" style={{
            fontSize: "clamp(18px, 1.8vw, 24px)"
          }}>
              Elevating your natural beauty with high-definition artistry for your most cherished moments.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" className="bg-[#D4AF9F] text-white hover:bg-[#C39E8E] font-sans font-semibold uppercase tracking-wider text-sm h-14 px-8 rounded-md shadow-sm">
                <Link to="/BridalSuitePage">
                  View Bridal Packages
                  <ArrowRight className="size-4" />
                </Link>
              </Button>

              <Button asChild variant="outline" size="lg" className="bg-white/50 backdrop-blur-sm border-[#1A1512]/20 text-[#1A1512] hover:bg-white/80 font-sans font-semibold uppercase tracking-wider text-sm h-14 px-8 rounded-md shadow-sm">
                <Link to="/PortfolioPage">View Portfolio</Link>
              </Button>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 lg:justify-self-end w-full lg:w-[280px]">
            <div className="bg-white/40 backdrop-blur-xl border border-white/40 p-6 rounded-lg shadow-md">
              <div className="flex items-center justify-between mb-4 pb-3 border-b border-[#1A1512]/10">
                <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#1A1512]/60">
                  Makeup Services
                </span>
                <span className="flex items-center gap-1.5">
                  <span className="block size-1.5 bg-[#D4AF9F] animate-pulse" />
                  <span className="font-mono text-[10px] uppercase tracking-wider text-[#D4AF9F]">Available</span>
                </span>
              </div>
              <div className="space-y-3">
                {conditions.map((c, i) => <div data-index={i} key={c.label} className="flex items-center justify-between">
                    <span className="font-mono text-[10px] uppercase tracking-[0.15em] text-[#1A1512]/50">
                      {c.label}
                    </span>
                    <span className="font-sans font-bold text-sm text-[#1A1512] tabular-nums">
                      {c.value}
                    </span>
                  </div>)}
              </div>
              <div className="mt-4 pt-3 border-t border-[#1A1512]/10 flex items-center justify-between">
                <span className="font-mono text-[10px] uppercase tracking-[0.15em] text-[#1A1512]/50">
                  Booking
                </span>
                <span className="font-mono text-[10px] uppercase tracking-wider text-[#D4AF9F]">Bookings Open</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}